import { render, staticRenderFns } from "./DealerRegister.vue?vue&type=template&id=39635368&scoped=true&"
import script from "./DealerRegister.vue?vue&type=script&lang=js&"
export * from "./DealerRegister.vue?vue&type=script&lang=js&"
import style0 from "./DealerRegister.vue?vue&type=style&index=0&id=39635368&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39635368",
  null
  
)

export default component.exports